import styled from 'styled-components';
import { techColors, neonGlow, terminalTextStyle } from './TechRetroEffects';

export { FormStatusMessage as ModalFormStatusMessage } from './StatusMessageStyles';

export const ModalForm = styled.form.withConfig({
  shouldForwardProp: (prop) => prop !== '$fullWidth' && prop !== '$flex',
})`
  width: 100%;
  max-width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '320px')};
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: stretch;
  flex: ${({ $flex }) => ($flex ? '1' : 'none')};
  min-height: ${({ $flex }) => ($flex ? '0' : 'auto')};
`;

export const ModalFormInput = styled.input.withConfig({
  shouldForwardProp: (prop) => prop !== '$hasError',
})`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid ${({ $hasError }) => ($hasError ? techColors.danger : techColors.borderSubtle)};
  border-radius: 4px;
  font-size: 12px;
  background-color: ${techColors.darkBg};
  color: ${techColors.textPrimary};
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  ${terminalTextStyle}

  &:focus {
    outline: none;
    border-color: ${({ $hasError }) => ($hasError ? techColors.danger : 'rgba(255, 255, 255, 0.28)')};
    ${({ $hasError }) => !$hasError && neonGlow(techColors.neonCyan, 'subtle')}
  }

  &::placeholder {
    color: ${techColors.textSecondary};
    opacity: 0.6;
  }
`;

export const ModalFormCodeInput = styled(ModalFormInput)`
  width: 132px;
  max-width: 100%;
  align-self: center;
  text-align: center;
  letter-spacing: 0.18em;
  font-size: 14px;
  padding: 8px 10px;

  &::placeholder {
    letter-spacing: normal;
    font-size: 12px;
  }
`;

export const ModalFormHint = styled.p`
  font-size: 10px;
  color: ${techColors.textSecondary};
  margin: 4px 0 2px;
  text-align: left;
  line-height: 1.4;
  ${terminalTextStyle}
`;

export const ModalFormStatus = styled.div`
  min-height: 44px;
  display: flex;
  align-items: center;
  width: 100%;
`;

